<template>
  <ons-page id="about-us">
    <app-bar :title="$t('about_us.title')" :enable-home="false" />
    <div class="container">
      <p>{{ $t("about_us.p1") }}</p>
      <p>{{ $t("about_us.p2") }}</p>
      <p>{{ $t("about_us.p3") }}</p>
      <ul>
        <li>{{ $t("about_us.feature1") }}</li>
        <li>{{ $t("about_us.feature2") }}</li>
        <li>{{ $t("about_us.feature3") }}</li>
        <li>{{ $t("about_us.feature4") }}</li>
        <li>{{ $t("about_us.feature5") }}</li>
        <li>{{ $t("about_us.feature6") }}</li>
      </ul>
      <!-- TODO uncomment when launch the feature. show google / itune depending on the platform -->
      <!-- <p>Edifi is listener-supported. If you choose to purchase Edifi Premium, payment will be charged to your Google Play / iTunes account, and your account will be charged for renewal 24 hours prior to the end of the current period. Auto-renewal may be turned off at any time by going to your settings in the Google Play / iTunes Store after purchase. The price for Edifi Premium is yet to be determined, and may vary from country to country.</p> -->
    </div>
    <ons-list>
      <ons-list-item expandable>
        {{ $t("contact_us.title") }}
        <div class="expandable-content">
          <p>{{ $t("contact_us.email_label") }} - <a href="mailto:support@edifi.app">support@edifi.app</a></p>
          <p>{{ $t("contact_us.address_label") }}</p>
          <p>The Christian Post</p>
          <p>6200 Second Street, NW</p>
          <p>Washington, DC 20011</p>
          <p>{{ $t("contact_us.info_label") }} - 202-506-4706</p>
        </div>
      </ons-list-item>
      <ons-list-item expandable>
        {{ $t("privacy_policy.title") }}
        <div class="expandable-content">
          <pre>{{ $t("privacy_policy.last_updated") }}</pre>
          <p>{{ $t("privacy_policy.p1") }}</p>
          <p>{{ $t("privacy_policy.p2") }}</p>
          <p>{{ $t("privacy_policy.p3") }}</p>
          <h2>{{ $t("privacy_policy.h1") }}</h2>
          <p>{{ $t("privacy_policy.p4") }}</p>
          <h3>{{ $t("privacy_policy.h1_1") }}</h3>
          <p>{{ $t("privacy_policy.p5") }}</p>
          <h3>{{ $t("privacy_policy.h1_2") }}</h3>
          <p>{{ $t("privacy_policy.p6") }}</p>
          <h3>{{ $t("privacy_policy.h1_3") }}</h3>
          <p>{{ $t("privacy_policy.p7") }}</p>
          <h3>{{ $t("privacy_policy.h1_4") }}</h3>
          <p>{{ $t("privacy_policy.p8") }}</p>
          <h3>{{ $t("privacy_policy.h1_5") }}</h3>
          <p>{{ $t("privacy_policy.p9") }}</p>
          <h2>{{ $t("privacy_policy.h2") }}</h2>
          <p>{{ $t("privacy_policy.p10") }}</p>
          <ol>
            <li>{{ $t("privacy_policy.data_usage1") }}</li>
            <li>{{ $t("privacy_policy.data_usage2") }}</li>
            <li>{{ $t("privacy_policy.data_usage3") }}</li>
            <li>{{ $t("privacy_policy.data_usage4") }}</li>
            <li>{{ $t("privacy_policy.data_usage5") }}</li>
            <li>{{ $t("privacy_policy.data_usage6") }}</li>
            <li>{{ $t("privacy_policy.data_usage7") }}</li>
            <li>{{ $t("privacy_policy.data_usage8") }}</li>
            <li>{{ $t("privacy_policy.data_usage9") }}</li>
            <li>{{ $t("privacy_policy.data_usage10") }}</li>
            <li>{{ $t("privacy_policy.data_usage11") }}</li>
            <li>{{ $t("privacy_policy.data_usage12") }}</li>
          </ol>
          <h2>{{ $t("privacy_policy.h3") }}</h2>
          <p>{{ $t("privacy_policy.p11") }}</p>
          <h3>{{ $t("privacy_policy.h3_1") }}</h3>
          <p>{{ $t("privacy_policy.p12") }}</p>
          <h3>{{ $t("privacy_policy.h3_2") }}</h3>
          <p>{{ $t("privacy_policy.p13") }}</p>
          <h3>{{ $t("privacy_policy.h3_3") }}</h3>
          <p>{{ $t("privacy_policy.p14") }}</p>
          <h3>{{ $t("privacy_policy.h3_4") }}</h3>
          <p>{{ $t("privacy_policy.p15") }}</p>
          <h3>{{ $t("privacy_policy.h3_5") }}</h3>
          <p>{{ $t("privacy_policy.p16") }}</p>
          <h3>{{ $t("privacy_policy.h3_6") }}</h3>
          <p>{{ $t("privacy_policy.p17") }}</p>
          <h3>{{ $t("privacy_policy.h3_7") }}</h3>
          <p>{{ $t("privacy_policy.p18") }}</p>
          <h3>{{ $t("privacy_policy.h3_8") }}</h3>
          <p>{{ $t("privacy_policy.p19") }}</p>
          <h3>{{ $t("privacy_policy.h3_9") }}</h3>
          <p>{{ $t("privacy_policy.p20") }}</p>
          <h2>{{ $t("privacy_policy.h4") }}</h2>
          <h3>{{ $t("privacy_policy.h4_1") }}</h3>
          <p>{{ $t("privacy_policy.p21") }}</p>
          <h3>{{ $t("privacy_policy.h4_2") }}</h3>
          <p>{{ $t("privacy_policy.p22") }}</p>
          <h3>{{ $t("privacy_policy.h4_3") }}</h3>
          <p>{{ $t("privacy_policy.p23") }}</p>
          <ul>
            <li>{{ $t("privacy_policy.3rd_party_setting1") }}</li>
            <li>{{ $t("privacy_policy.3rd_party_setting2") }}</li>
          </ul>
          <p>{{ $t("privacy_policy.p24") }}</p>
          <h2>{{ $t("privacy_policy.h5") }}</h2>
          <p>{{ $t("privacy_policy.p25") }}</p>
          <h2>{{ $t("privacy_policy.h6") }}</h2>
          <p>{{ $t("privacy_policy.p26") }}</p>
          <h2>{{ $t("privacy_policy.h7") }}</h2>
          <p>{{ $t("privacy_policy.p27") }}</p>
          <h2>{{ $t("privacy_policy.h8") }}</h2>
          <p>{{ $t("privacy_policy.p28") }}</p>
          <p>{{ $t("privacy_policy.p29") }}</p>
        </div>
      </ons-list-item>
      <ons-list-item expandable>
        {{ $t("terms.title") }}
        <div class="expandable-content">
          <h3>{{ $t("terms.h1") }}</h3>
          <p>{{ $t("terms.p1") }}</p>
          <p>{{ $t("terms.p2") }}</p>
          <p>{{ $t("terms.p3") }}</p>
          <p><strong>{{ $t("terms.p4") }}</strong></p>
          <h3>{{ $t("terms.h2") }}</h3>
          <p>{{ $t("terms.p5") }}</p>
          <p>{{ $t("terms.p6") }}</p>
          <h3>{{ $t("terms.h3") }}</h3>
          <p>{{ $t("terms.p7") }}</p>
          <h3>{{ $t("terms.h4") }}</h3>
          <p>{{ $t("terms.p8") }}</p>
          <h3>{{ $t("terms.h5") }}</h3>
          <p>{{ $t("terms.p9") }}</p>
          <h3>{{ $t("terms.h6") }}</h3>
          <p>{{ $t("terms.p10") }}</p>
          <p>{{ $t("terms.p11") }}</p>
          <p>{{ $t("terms.p12") }}</p>
          <p>{{ $t("terms.p13") }}</p>
          <ul class="bullets">
            <li>{{ $t("terms.forbidden_user_actions1") }}</li>
            <li>{{ $t("terms.forbidden_user_actions2") }}</li>
            <li>{{ $t("terms.forbidden_user_actions3") }}</li>
            <li>{{ $t("terms.forbidden_user_actions4") }}</li>
            <li>{{ $t("terms.forbidden_user_actions5") }}</li>
            <li>{{ $t("terms.forbidden_user_actions6") }}</li>
            <li>{{ $t("terms.forbidden_user_actions7") }}</li>
            <li>{{ $t("terms.forbidden_user_actions8") }}</li>
            <li>{{ $t("terms.forbidden_user_actions9") }}</li>
          </ul>
          <p>{{ $t("terms.p14") }}</p>
          <p>{{ $t("terms.p15") }}</p>
          <h3>{{ $t("terms.h7") }}</h3>
          <p>{{ $t("terms.p16") }}</p>
          <p>{{ $t("terms.p17") }}</p>
          <p>{{ $t("terms.p18") }}</p>
          <h3>{{ $t("terms.h8") }}</h3>
          <p>{{ $t("terms.p19") }}</p>
          <p>{{ $t("terms.p20") }}</p>
          <h3>{{ $t("terms.h9") }}</h3>
          <p>{{ $t("terms.p21") }}</p>
          <h3>{{ $t("terms.h10") }}</h3>
          <p>{{ $t("terms.p22") }}</p>
          <p>{{ $t("terms.p23") }}</p>
          <p>{{ $t("terms.p24") }}</p>
          <p>{{ $t("terms.p25") }}</p>
          <h3>{{ $t("terms.h11") }}</h3>
          <p>{{ $t("terms.p26") }}</p>
          <h3>{{ $t("terms.h12") }}</h3>
          <p>{{ $t("terms.p27") }}</p>
          <h3>{{ $t("terms.h13") }}</h3>
          <p>{{ $t("terms.p28") }}</p>
          <p>{{ $t("terms.p29") }}</p>
          <h3>{{ $t("terms.h14") }}</h3>
          <p>{{ $t("terms.p30") }}</p>
          <h3>{{ $t("terms.h15") }}</h3>
          <p>{{ $t("terms.p31") }}</p>
          <p>{{ $t("terms.p32") }}</p>
          <p></p>
          <ul>
            <li>{{ $t("terms.copyright_notice_info1") }}</li>
            <li>{{ $t("terms.copyright_notice_info2") }}</li>
            <li>{{ $t("terms.copyright_notice_info3") }}</li>
            <li>{{ $t("terms.copyright_notice_info4") }}</li>
            <li>{{ $t("terms.copyright_notice_info5") }}</li>
            <li>{{ $t("terms.copyright_notice_info6") }}</li>
            <li>{{ $t("terms.copyright_notice_info7") }}</li>
          </ul>
          <p><strong>{{ $t("terms.p33_1") }}<br></strong> The Christian Post, Inc. <br> 6200 Second Street, NW <br> Washington, DC 20011 <br> USA <br> {{ $t("terms.p33_2") }}<br> {{ $t("terms.p33_tel") }}202.506.4706 <br> {{ $t("terms.p33_email") }}<a href="mailto:support@edifi.app">support@edifi.app</a></p>
          <h3>{{ $t("terms.h16") }}</h3>
          <p>{{ $t("terms.p34") }}</p>
        </div>
      </ons-list-item>
      <ons-list-item expandable>
        {{ $t("disclaimer.title") }}
        <div class="expandable-content">
          <p>{{ $t("disclaimer.p1") }}</p>
          <p>{{ $t("disclaimer.p2") }}</p>
          <p>{{ $t("disclaimer.p3") }}</p>
        </div>
      </ons-list-item>
    </ons-list>
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';

export default {
  name: 'about-us',
  components: {
    'app-bar': AppBar
  },
};
</script>
